import { effect, inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs/operators';

const SUPPORTED_LANGUAGES = ['en', 'pl'];

@Injectable({ providedIn: 'root' })
export class LanguageService {
  private _translate: TranslateService = inject(TranslateService);
  private _languageSignal = toSignal(this._translate.onLangChange.pipe(map((e) => e.lang)));

  public init(): void {
    this._setupLanguageSelectPersistence();
    this._translate.addLangs(SUPPORTED_LANGUAGES);
    this._translate.setDefaultLang(this._defaultLanguage());
    this._translate.use(this._defaultLanguage());
  }

  private _defaultLanguage(): string {
    const browserLang = this._translate.getBrowserLang();
    const defaultLang = SUPPORTED_LANGUAGES.find((lang) => lang === browserLang) || 'en';
    return localStorage.getItem('lang') || defaultLang;
  }

  private _setupLanguageSelectPersistence(): void {
    effect(() => {
      localStorage.setItem('lang', this._languageSignal() || 'en');
    });
  }
}
